import { render, staticRenderFns } from "./Basketball.vue?vue&type=template&id=072891d0&"
import script from "./Basketball.vue?vue&type=script&lang=ts&"
export * from "./Basketball.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports